import { render, staticRenderFns } from "./lealtad-estrateca-acumular.vue?vue&type=template&id=f5b6a3bc&"
import script from "./lealtad-estrateca-acumular.vue?vue&type=script&lang=js&"
export * from "./lealtad-estrateca-acumular.vue?vue&type=script&lang=js&"
import style0 from "./lealtad-estrateca-acumular.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports